import React from 'react';
import { Vehicle, VehicleStatus } from '@esportal/portal-service';
import { Guantera } from '../../guantera';
import { GuanteraDataListClient } from './guantera-data-list-client';

export const GuanteraClient = ({ vehicles }: { vehicles: Vehicle[] | undefined }) => {
	if (!vehicles) {
		return <></>;
	}

	const filteredVehicles = vehicles.filter(
		(vehicle: Vehicle) =>
			vehicle.status === VehicleStatus.READY ||
			vehicle.status === VehicleStatus.TO_BE_CONFIRMED ||
			vehicle.status === VehicleStatus.TO_BE_DELETED,
	);

	if (filteredVehicles.length === 0) {
		return null;
	}

	return (
		<Guantera isClient={true}>
			<GuanteraDataListClient />
		</Guantera>
	);
};
